import React from 'react'
import ReactDOM from 'react-dom'
import * as serviceWorker from './serviceWorker'
import '@fortawesome/fontawesome-free/css/all.min.css'
import App from './app/app'
import { axiosProgressBarInterceptor } from './infrastructure/axios/axiosProgressBarInterceptor'
import { axiosErrorInterceptor } from './infrastructure/axios/axiosErrorInterceptor'
import { axiosAuthInterceptor } from './infrastructure/axios/axiosAuthInterceptor'

axiosProgressBarInterceptor()
axiosErrorInterceptor()
axiosAuthInterceptor()

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
